var _style, _g, _path, _path2, _polygon, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRadisys(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 233 60.6",
    style: {
      enableBackground: "new 0 0 233 60.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#FF0000;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:#DD1C4C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.2,
    y: 8,
    className: "st1",
    width: 350.3,
    height: 141.3
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1,
    y1: -889.9001,
    x2: 37.975,
    y2: -889.9001,
    gradientTransform: "matrix(1 0 0 -1 0 -867.6001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#282A2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666666",
      stopOpacity: 0.5
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30.7,0.9c6.1,0,9.1,5.1,6.1,8.6H9.7v26L1,43.7V0.9H30.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M36.8,9.5l-12.1,12l24.3,24h12.1l-24.3-24l6.1-5.9c3.3-3.3,3.3-8.8,0-12.1C41.3,1.9,39.1,1,36.8,1h-6.1 C36.8,0.9,39.8,6.1,36.8,9.5z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "1,43.7 18,27.5 23.8,33.2 9.7,46.7 1,46.7 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M63,34.8c0-4.4,2.5-7.9,8.2-7.9c0,0,10,0.1,10,0c0,0,0.1-2.5,0-2.6c0-3.2-1.6-4-4.2-4c-3.1,0-9.6,0.4-13.1,0.6 v-4.2c3.9-1.4,8.3-1.8,13.8-1.9c5.7,0,9.9,2.3,9.9,9.2v21h-5l-1.4-3.4C81,42,75.7,45.4,71,45.3c-5.1-0.1-8-3.5-8-7.7V34.8z M72.4,40 c3.7,0,8.8-2.5,8.8-2.5v-6.3l-9,0.7c-2.2,0.2-2.7,1.8-2.7,3.2V37C69.4,39.6,70.8,40,72.4,40z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M104.8,15.2c2.5,0,6.6,0.7,9.7,2V1.5h6.4v43.7h-5.1l-1.3-3.1c-1.7,1.3-6,3.4-9.6,3.4c-7.6,0-9.7-6.6-9.7-15 C95.1,21.8,96.5,15.2,104.8,15.2z M106.1,39.8c2.9,0,5.8-0.7,8.4-2.1V21.8c-2.7-0.9-5.1-1.2-8.4-1.2c-2.9,0-4.5,1.7-4.5,9.8 C101.6,37.2,103.2,39.8,106.1,39.8L106.1,39.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M128.8,6.9c0-0.8,0.4-1.4,1.3-1.4h4.7c0.8,0,1.3,0.6,1.3,1.4v4.2c0,0.8-0.5,1.3-1.3,1.3h-4.7 c-0.8,0-1.3-0.5-1.3-1.3V6.9z M129.2,15.6h6.5v29.6h-6.5V15.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M143.1,23.1c0-4.6,1.9-7.7,7.7-7.7c4.7,0,12.8,0.3,15.3,1.3V21h-13.8c-2.6,0-2.7,0.9-2.7,2.5v1.8 c0,2.3,1.2,2.4,2.7,2.4h7.7c5.4,0,7.6,3.2,7.6,7.5V38c0,6.1-3.7,7.5-7.2,7.5c-4.6,0-14-0.5-16-1.4v-4.2h14.4c0.3,0,2.4,0.1,2.4-2.3 v-1.9c0-1.5-0.5-2.3-2.4-2.3h-7.6c-5.2,0-8.1-2-8.1-7.7L143.1,23.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M179.6,15.6l5.9,21.6c0.8,2.7,3,2.2,3.2,2.2l6.8-23.7h6.8L191,54.6l-4.1,5.7h-4.5l4.6-15c-3,0-6.4-1.4-8-7 l-6.3-22.5L179.6,15.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M207.5,23.1c0-4.6,1.9-7.7,7.7-7.7c4.7,0,12.8,0.3,15.3,1.3V21h-13.8c-2.6,0-2.7,0.9-2.7,2.5v1.8 c0,2.3,1.2,2.4,2.7,2.4h7.7c5.4,0,7.6,3.2,7.6,7.5V38c0,6.1-3.7,7.5-7.2,7.5c-4.6,0-14-0.5-16-1.4v-4.2h14.4c0.3,0,2.4,0.1,2.4-2.3 v-1.9c0-1.5-0.5-2.3-2.4-2.3h-7.6c-5.2,0-8.1-2-8.1-7.7L207.5,23.1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadisys);
export default __webpack_public_path__ + "static/media/radisys.5067b9071522886962496aeb26025584.svg";
export { ForwardRef as ReactComponent };